module.exports = __webpack_public_path__ + "static/img/img12.8ed8549.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images_member/img12.png
// module id = 4Ych
// module chunks = 1